import React, { PropsWithChildren } from 'react';
import { Container } from 'react-bootstrap';
import { PhoneIcon, MailIcon, AddressIcon, DocumentIcon } from './svg/Icons';
import { helpMail, helpPhone1, helpPhone2 } from '../model/Const';
import { prettyPrintPLPhoneNumber } from '../common/utl/PhoneNumberUtils';
import { isTestEnv, version } from '../common/appVersion';
import { usePolicy } from './GlobalStateContext';
import { Value } from '../common/state/State';
import { DocToJSON } from '../common/form/DocToJSON';
import { DocFromJSON } from '../common/form/DocFromJSON';
import { PublicBucketUrl, WDBInfoPath, WDBLicensePath, PrivacyPolicyPath, RulesPath } from '../model/consent/Consent';
import { AffiliateLink } from './AffiliateLink';

function Group(props: PropsWithChildren<{}>)
{
  return (
    <div className="pt-5">
      {props.children}
    </div>
  );
}


function Header(props: PropsWithChildren<{}>)
{
  return (
    <div className="footerHeader">
      {props.children}
    </div>
  );
}

function Item(props: PropsWithChildren<{ href: string }>)
{
  const href = props.href ?? '';
  const external = href.startsWith('http');
  const content = props.children;

  return (
    <div className="footerItem mb-3">
      <DocumentIcon className="mr-3" style={{ width: 24, height: 32, fill: 'white' }} />
      {external
        ? <a href={href} target="_blank" >
          {content}
        </a>
        : <AffiliateLink to={href} >
          {content}
        </AffiliateLink>
      }
    </div>
  );
}

export const Footer: React.FunctionComponent<{}> = () => (
  <footer className="">
    <Container fluid={true}>
      <Container style={{ maxWidth: 1400 }}>
        <div className="footerLayout">
          <Group>
            <Header>
              WDB S.A.
            </Header>
            <div className="mt-4 fs-16 fw-400" style={{ maxWidth: 400, lineHeight: '24px' }}>
              <div className="mt-4 d-flex">
                <PhoneIcon style={{ width: 24, height: 'auto', fill: 'white' }} />
                <div>
                  <a
                    style={{ color: 'white' }}
                    className="ml-2"
                    href={'tel:' + helpPhone1}
                  >
                    {prettyPrintPLPhoneNumber(helpPhone1)}
                  </a>
                  <br />
                  <a
                    style={{ color: 'white' }}
                    className="ml-2"
                    href={'tel:' + helpPhone2}
                  >
                    {prettyPrintPLPhoneNumber(helpPhone2)}
                  </a>
                </div>
              </div>
              <div className="mt-3">
                <MailIcon style={{ width: 24, height: 'auto', fill: 'white' }} />
                <a
                  style={{ color: 'white' }}
                  className="ml-2"
                  href={'mailto:' + helpMail}
                >
                  {helpMail}
                </a>
              </div>
              <div className="d-flex mt-3">
                <div className="mr-2 align-self-center">
                  <AddressIcon style={{ width: 'auto', height: '34px', fill: 'white' }} />
                </div>
                <div className="d-flex flex-column" style={{ lineHeight: '24px' }}>
                  <span>
                    ul. Fiołkowa 3
                  </span>
                  <span>
                    52 -200 Wysoka
                  </span>
                </div>
              </div>
            </div>
          </Group>
          <Group>
            <Header>
              Informacje
            </Header>
            <div className="mt-4">
              <Item href={PublicBucketUrl + WDBInfoPath}>Informacja o dystrybutorze</Item>
              <Item href={PublicBucketUrl + WDBLicensePath}>Zezwolenie WDB S.A.</Item>
              <Item href={PublicBucketUrl + PrivacyPolicyPath}>Polityka prywatności</Item>
              <Item href={PublicBucketUrl + RulesPath}>Regulamin</Item>
            </div>
          </Group>
        </div>
      </Container>
    </Container>
    <br />
    <div id="versionInfo">
      <div className="d-flex justify-content-end">
        <small className="mr-2">Wersja: {version}</small>
      </div>
      {isTestEnv &&
        <div style={{ backgroundColor: 'red' }}>
          <div className="d-flex justify-content-center">
            <h2>Wersja testowa: {version}</h2>
          </div>
          <DbgButtons />
        </div>
      }
    </div>
  </footer>
);

function DbgButtons()
{
  const policy = usePolicy();

  return <div>
    <DocToJSON
      doc={policy}
    />
    <DocFromJSON
      doc={policy}
      visible={new Value('docToJsonVisible', policy.formSource)}
    />
    <div>
      Kod partnerski: {policy.formData.affiliateCode.getValue() ?? 'Brak'}
    </div>
  </div>;
}
